var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Edit_Icon",
    "data-name": "Edit Icon",
    d: "M18.646-1.2a1.022,1.022,0,0,1,.725.3L24.5,4.229a1.026,1.026,0,0,1,0,1.45L11.679,18.5a1.026,1.026,0,0,1-.725.3H5.826A1.026,1.026,0,0,1,4.8,17.774V12.646a1.026,1.026,0,0,1,.3-.725L17.921-.9A1.022,1.022,0,0,1,18.646-1.2Zm3.678,6.154L18.646,1.276,6.851,13.071v3.678h3.678Z",
    transform: "translate(-4.8 1.2)",
    fill: "#474b4f",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit_Icon.8200d70ddb09a5a1345feb7e7a7eca6f.svg";
export { ForwardRef as ReactComponent };